import { render, staticRenderFns } from "./ResultDigitDisplay.vue?vue&type=template&id=5f0b3fbc&scoped=true&"
import script from "./ResultDigitDisplay.vue?vue&type=script&lang=js&"
export * from "./ResultDigitDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ResultDigitDisplay.vue?vue&type=style&index=0&id=5f0b3fbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0b3fbc",
  null
  
)

export default component.exports